import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page9',
  templateUrl: './page9.component.html',
  styleUrls: ['./page9.component.css']
})
export class Page9Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
